import React, { Component } from 'react';
import { Table, Icon } from "antd";
import { connect } from "react-redux";
import { deleteUser, getUserInfo } from "../redux/actions/Users";
import { get, post } from "../lib/api";
import { bindActionCreators } from "redux";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class UsersList extends Component {
  state = {
    users: [],
    columns: [
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        align: 'center',
      },
      {
        title: 'Clave',
        dataIndex: 'passwordHash',
        key: 'passwordHash',
        align: 'center',
      },
      {
        title: "Acciones",
        key: "uid",
        dataIndex: "uid",
        render: id => (
          <div>
            <Icon style={{ marginRight: 5, marginLeft: 5 }} type="eye" />
            {/* <Icon style={{marginRight: 5, marginLeft: 5}} type="edit" onClick={() => this.handleEdit(id)}/> */}
            <Icon style={{ marginRight: 5, marginLeft: 5 }} type="delete" onClick={() => this.confirm(id)} />
          </div>
        ),
        align: 'center',
      }
    ]
  }

  handleDelete = async (uid) => {
    var data = await post("deleteUser", { uid });
    data.success && this.getUsers();
  }

  confirm = (uid) => {
    confirmAlert({
      title: 'Confirmar para borrar',
      message: '¿Está seguro de que desea eliminar a este usuario?',
      buttons: [
        {
          label: 'Sí',
          onClick: () => this.handleDelete(uid)
        },
        {
          label: 'No'
        }
      ]
    });
  };

  async componentWillMount() {
    this.getUsers();
  }

  async getUsers() {
    var data = await get('getUsers');
    if (data.success) {
      await this.setState({ users: data.data.users })
    }

  }

  handleEdit = (uid) => {
    this.props.getUserInfo(uid)
    this.props.history.push("/editUser")
  }

  render() {
    if (this.state.users[0]) {
      return (
        <div style={{ paddingTop: 50 }}>
          <Table dataSource={this.state.users} columns={this.state.columns} />
        </div>
      )
    } else {
      return (
        <div style={{ display: "flex", height: "100vh", justifyContent: "center", alignItems: "center" }}>
          <h2 style={{color: "#bdbdbd"}}>Loading...</h2>
        </div>
      )
    }
  }
}

const mapStateToProps = state => {
  return {
    users: state.users.data,
    firebase: state.firebase
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ deleteUser, getUserInfo }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersList)